import {AuthenticateModel, AuthenticateModelReturn} from "../models/authentication/AuthenticateModel";
import {SystemMemoryProps} from "../models/SystemMemoryProps";
import {MemoryModel} from "../models/MemoryModel";
import {Dispatch, SetStateAction} from "react";
import {HTTPError} from "../models/errors/HTTPError";

export class Authentication {
    private readonly AuthApiPath: string
    private readonly GetMemory: MemoryModel;
    private readonly PutMemory: Dispatch<SetStateAction<MemoryModel>>;

    constructor({memory}: SystemMemoryProps) {
        this.AuthApiPath =  "/auth"
        this.GetMemory = memory[0];
        this.PutMemory = memory[1];
    }

    public async Authenticate(body: AuthenticateModel) {
        const init = {
            body: JSON.stringify(body),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include' as RequestCredentials,
            method: 'POST'
        };
        const data = await fetch(this.GetMemory.ApiURL + this.AuthApiPath + "/login", init);

        if (data.status === 200) {
            let token: AuthenticateModelReturn = await data.json();

            // Set accessToken in local memory
            this.GetMemory.AccessToken = token.accessToken;
            this.GetMemory.isSignedIn = true;

            this.PutMemory(this.GetMemory)
        }
        else {
            throw new HTTPError(data.status, (await data.text()).replaceAll('"', ""))
        }
    }

    public async RefreshJwT() {
        const init = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include' as RequestCredentials,
            method: 'GET'
        };

        const data = await fetch(this.GetMemory.ApiURL + this.AuthApiPath + "/refresh", init);

        // If the response is successful, update the JWT
        if (data.status === 200) {
            let token: AuthenticateModelReturn = await data.json();

            // Set accessToken in local memory
            this.GetMemory.AccessToken = token.accessToken;
            this.GetMemory.isSignedIn = true;

            this.PutMemory(this.GetMemory)
        }
        else {
            if (data.status === 401) {
                // Clear the accessToken in local memory
                this.GetMemory.AccessToken = "";
                this.GetMemory.isSignedIn = false;

                this.PutMemory(this.GetMemory)
            }
            throw new HTTPError(data.status, (await data.text()).replaceAll('"', ""))
        }
    }
}